import { createFileRoute } from "@tanstack/react-router";
import { Intercom } from "@/components/Intercom";

function RouteComponent() {
  return <Intercom />;
}

export const Route = createFileRoute("/_authenticated/intercom/")({
  component: RouteComponent,
  staticData: { page: "support" },
});
